import React, { useState, useMemo } from "react";
import { Typography, Chip, Avatar, Tooltip } from "@mui/material";
import CustomTable from "../../components/Table/Table";
import { useAllProjectHistoryViewModel } from "./AllProjectHistoryViewModel";
import { useResourceApi } from "../../hooks/useResourceApi";
import formFields from "../../config/formFields.json";
import { getEnumLabel } from "../../utils/enumUtils";

const AllProjectHistory = ({ projectId }) => {
  const {
    cacheOperations: { readResources },
  } = useResourceApi();

  const formField = formFields.project.basic.fields;

  const getResourceName = useMemo(
    () => (id) => {
      if (!id) return "N/A";
      const resources = readResources();
      const resource = resources.find(
        (r) => Number(r.resource_id) === Number(id)
      );
      return resource
        ? `${resource.first_name} ${resource.last_name} | ${resource.email}`
        : "N/A";
    },
    [readResources]
  );

  const { history, error } = useAllProjectHistoryViewModel(projectId);

  const columns = [
    {
      id: "field_name",
      label: "Field Name",
      render: (value) => {
        console.log("value", value);

        for (const field in formField) {
          if (field == value) {
            return formField[field].label;
          }
        }
      },
    },
    {
      id: "old_value",
      label: "Old Value",
      render: (value, row) => {
        const allowedFields = ["project_status_code", "project_model"];
        const fieldName = row?.field_name;
        let displayValue = value;

        if (allowedFields.includes(fieldName)) {
          for (const field in formField) {
            if (field === fieldName) {
              displayValue = getEnumLabel(fieldName, value);
            }
          }
        }

        return (
          <Tooltip title={displayValue || ""} arrow placement="top">
            <Typography
              sx={{
                maxWidth: "200px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontSize: "inherit"
              }}
            >
              {displayValue}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      id: "new_value",
      label: "New Value",
      render: (value, row) => {
        const allowedFields = ["project_status_code", "project_model"];
        const fieldName = row?.field_name;
        let displayValue = value;

        if (allowedFields.includes(fieldName)) {
          for (const field in formField) {
            if (field === fieldName) {
              displayValue = getEnumLabel(fieldName, value);
            }
          }
        }

        return (
          <Tooltip title={displayValue || ""} arrow placement="top">
            <Typography
              sx={{
                maxWidth: "200px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontSize: "inherit"
              }}
            >
              {displayValue}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      id: "changed_by",
      label: "Changed By",
      render: (value) => getResourceName(value),
      searchValue: (value) => getResourceName(value),
    },

    {
      id: "created_on",
      label: "Created On",
      align: "left",
      render: (value) => {
        if (!value) return "-";
        const [day, month, year] = value.split("/");
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      },
    },
  ];

  if (error) {
    return (
      <div>
        <Typography color="error">Error: {error}</Typography>
      </div>
    );
  }

  return (
    <div>
      <CustomTable
        columns={columns}
        data={history}
        showSearch={false}
        showActions={false}
        showColumnVisibility={false}
        pageSize={10}
        showAddButton={false}
        stickyHeader={true}
        getResourceName={getResourceName}
        title="Project Change Log"
        subtitle="Monitor your project change log"
        alignment="left"
        fontSize="12px"
      />
    </div>
  );
};

export default AllProjectHistory;
